var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 198,
    height: 174.598,
    viewBox: "0 0 198 174.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-447 -271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67997",
    "data-name": "Group 67997",
    transform: "translate(447 271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M-1062.793,1244h-97.624v21.3h133.454",
    transform: "translate(1224.96 -1090.699)",
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899-2",
    "data-name": "Path 899",
    d: "M-1141.835,1113.918l25.434-.36-.2.411,86.387,174.085-35.827-21.3-63.165-127.361Z",
    transform: "translate(1228.218 -1113.559)",
    fill: "#39fffc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899-3",
    "data-name": "Path 899",
    d: "M-1103.731,1113.992l.2-.411h-25.611l.178.359-86.38,174.087h25.251l73.754-148.612Z",
    transform: "translate(1215.341 -1113.556)",
    fill: "#ed1cb5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.c70ea972e4fe8c67f8dbf6eb1d8bfa47.svg";
export { ForwardRef as ReactComponent };